import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  cartProductRemove,
  cartQtyDecrement,
  cartQtyIncrement
} from "../../redux/cart/actions";
import { productQtyMinus, productQtyPlus } from "../../redux/product/actions";

const ItemCard = ({ product }) => {
  // Product quantity for increment button disable
  const stockProduct = useSelector((state) =>
    state?.product?.find((stProduct) => stProduct?.id === product?.id)
  );

  const dispatch = useDispatch();

  const productQtyIncrement = () => {
    dispatch(cartQtyIncrement(product?.id, 1));
    dispatch(productQtyMinus(product?.id, 1));
  };

  const productQtyDecrement = () => {
    dispatch(productQtyPlus(product?.id, 1));
    dispatch(cartQtyDecrement(product?.id, 1));
  };

  const productDeleteToCart = async () => {
    await dispatch(productQtyPlus(product?.id, product?.quantity));
    await dispatch(cartProductRemove(product?.id));
  };

  return (
    <div className="flex justify-between border-b-2 mb-2">
      <div className="text-lg py-2">
        <p>{product?.name}</p>
      </div>
      <div className="text-lg py-2">
        <div className="flex flex-row space-x-2 w-full items-center rounded-lg">
          <button
            onClick={productQtyDecrement}
            disabled={product?.quantity < 2 ? true : false}
            className="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center disabled:bg-gray-400"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M18 12H6"
              />
            </svg>
          </button>
          <p>{product?.quantity}</p>
          <button
            onClick={productQtyIncrement}
            disabled={stockProduct?.quantity < 1 ? true : false}
            className="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center disabled:bg-gray-400"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>
          </button>
          <button
            onClick={productDeleteToCart}
            className="focus:outline-none bg-gray-50 hover:bg-gray-100 text-white font-bold py-[3px] px-[3px] rounded-full inline-flex items-center w-7"
          >
            <img className="w-full" alt="Delete icon" src="/delete.png" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ItemCard;
